const BYTES_IN_GB = 1024 * 1024 * 1024;

export const formatBytes = (bytes) => {
  const value = Number(bytes || 0);
  if (!value) return "0 GB";
  const gb = value / BYTES_IN_GB;
  if (gb >= 1) return `${gb.toFixed(2)} GB`;
  const mb = value / (1024 * 1024);
  return `${mb.toFixed(2)} MB`;
};

export const toGbValue = (bytes) => {
  const value = Number(bytes || 0);
  if (!value) return "";
  return Math.round((value / BYTES_IN_GB) * 100) / 100;
};

export const gbToBytes = (gbValue) => {
  const parsed = Number(gbValue);
  if (Number.isNaN(parsed)) return 0;
  return Math.round(parsed * BYTES_IN_GB);
};

export const formatLimit = (bytes) => {
  const value = Number(bytes || 0);
  if (!value) return "Unlimited";
  return formatBytes(value);
};

export const formatAdminLabel = (admin) => {
  if (!admin) return "";
  const company = admin.company_name || "";
  const name = admin.admin_name || "";
  if (company && name) return `${company} (${name})`;
  return company || name || admin.admin_id;
};

export { BYTES_IN_GB };
